export default __webpack_public_path__ + "images/ec6c6949fa3a2b12dc91c706597973df.jpg";